var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-label-group',{staticClass:"mb-2",attrs:{"label":_vm.calcLabel}},[_c('b-form-input',{staticClass:"phone-number-input",attrs:{"placeholder":_vm.calcLabel,"size":_vm.size || 'lg',"formatter":_vm.getFormattedNumber,"type":"tel"},on:{"blur":_vm.onBlur,"focus":_vm.onFocus},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6796e3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/PhoneNumberFieldLegacy.vue
// module id = 1308
// module chunks = 1